import { useMutation } from '@tanstack/react-query';

import type { DeleteEmployeeEmploymentArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: DeleteEmployeeEmploymentArgs) => {
  return employeeService.deleteEmployeeEmployment(data);
};

export const useEmployeeDeleteEmploymentMutation = () => {
  return useMutation<unknown, unknown, DeleteEmployeeEmploymentArgs>(mutationFn);
};
